(function () {
    'use strict';

    angular.module("imApp").factory("consignmentSplitService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1445,
                    parameters: parms || {}
                });
            },
            listSplits: function (parms) {
                return $ihttp.post({
                    method: 1446,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 1447,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
